import(/* webpackMode: "eager", webpackExports: ["Box","Grow","Paper","Typography"] */ "__barrel_optimize__?names=Box,Grow,Paper,Typography!=!/app/node_modules/@mui/material/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/bg.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo.png");
